export const GIT_REV = "80e98ff";
